export class OrderItemsCreateRequestModel {
    customerNo: string;
    collectionId: number;
    orderId: number;
    isDisplay: boolean;
    manualconfigSubsetIds?: Number[]
    constructor(customerNo: string, collectionId: number, orderId: number, isDisplay: boolean, manualconfigSubsetIds: Number[]) {
        this.customerNo = customerNo;
        this.collectionId = collectionId;
        this.orderId = orderId;
        this.isDisplay = isDisplay;
        this.manualconfigSubsetIds = manualconfigSubsetIds;
    }
}